import * as React from "react";
import ManagementHistoryActions from "./ManagementHistoryActions";


export const columns = (t) =>
    [

        {
            label: t ? t("common.date") : "Data",
            field: "date",
            width: 100,
            type: "badge"
        },
        {
            label: t ? t("forms.who") : "Kto",
            field: "user",
            width: 40,
            type: "badge"

        },
        {
            field: "actions",
            label: t ? t("forms.performed_actions") : "Wykonane czynności",
            sort: "desc",
            width: 30,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {

                return <ManagementHistoryActions
                    row={row}
                    history={history}
                    id={externalState}
                />;


            }

        }


    ]
;


export default columns;